// https://github.com/svivian/sv-hover-intent-js
SV=window.SV||{},SV.HoverIntent=function(e,t){const i={exitDelay:400,interval:100,sensitivity:7};let n,o,s,c,r,u,a,v={};const f=function(e){n=e.pageX,o=e.pageY},l=function(e){const t=s-n,i=c-o;if(Math.sqrt(t*t+i*i)<v.sensitivity){clearTimeout(a);for(let e of r)e.isActive&&(v.onExit(e),e.isActive=!1);v.onEnter(e),e.isActive=!0}else s=n,c=o,u=setTimeout((function(){l(e)}),v.interval)};!function(e,t){if(!t||!t.onEnter||!t.onExit)throw"onEnter and onExit callbacks must be provided";v=function(e,t){for(let i in t)e[i]=t[i];return e}(i,t),r=e;for(let e of r)e.isActive=!1,e.addEventListener("mousemove",f),e.addEventListener("mouseenter",(function(t){s=t.pageX,c=t.pageY,e.isActive?clearTimeout(a):u=setTimeout((function(){l(e)}),v.interval)})),e.addEventListener("mouseleave",(function(t){clearTimeout(u),e.isActive&&(a=setTimeout((function(){v.onExit(e),e.isActive=!1}),v.exitDelay))}))}(e,t)};

const populateTopProducts = (targetItem) => {
	const splitProductTitle = (productTitle) => {
		const productNameArr = productTitle.split(" - "); 
		if (productNameArr.length > 1) {
			productTitle = `
			<span class="split-product-title-family">${productNameArr[0]}</span>
			<span class="split-product-title-divider visually-hidden"> - </span>
			<span class="split-product-title-item">
			${productNameArr.slice(1).join(" - ")}
			</span>
			`;
		}
		return productTitle;
	}
	
	const shopifyLocale = `${window.Shopify.locale}-${window.Shopify.country}`;
	const currentCurrency =  window.Shopify.currency.active;
	
	// format the price using Shopify's currency formatting
	const priceFormatter = (price) => {
		const formattedPrice = parseFloat(price).toLocaleString(shopifyLocale, { style: 'currency', currency: currentCurrency });
		return formattedPrice;
	};

	const displayPrice = (product) => {
		if (shopifyLocale !== 'en-GB') {
			return '';
		};

		const price = product.min_price;
		const priceRange = price !== product.max_price;
		const onOffer = product.compare_at_price && product.compare_at_price > price;
		let html = '';

		html += `<p class="card-product-simple__price">
			${priceRange ? 'From ' : ''}
			${onOffer ? `<s class="was">${priceFormatter(product.compare_at_price)}</s> ` : ''}
			<strong class="money">${priceFormatter(price)}</strong>
		</p>`;

		return html;
	};
	
	const cleanCollection = (collectionName) => {
		let cleanCollection = collectionName;
	
		if (cleanCollection.includes('all')) {
			cleanCollection = 'all';
		}
	
		return cleanCollection;
	}
	
	// find .js-mm-featured-products and get the data attributes
	const featuredProducts = targetItem.querySelector('.js-mm-featured-products');
	const featuredProductsData = featuredProducts.dataset;
	const collection = cleanCollection(featuredProductsData.collectionName);
	const limit = featuredProductsData.availableCols;
	const populated = featuredProductsData.populated === 'true';

	if (collection && !populated) {
		featuredProducts.innerHTML = '';
		  const url = `/collections/${collection}/products.json?limit=${limit}`;
		//const url = `https://api-b7f90015.moot.tech/mv/api/2023-01/sprl_uk/quantlet/calc_trending_trans_lst_prd?object_id=${collection}`;
		fetch(url)
			.then(response => response.json())
			.then(data => {
				let products = data.products;
                console.log(products);
				let productHTML = '';
				products = products.filter(product => !product.title.includes("Face")); // remove face wraps as pop up a lots
				products.length = limit; // limit the number of products
				const siteRoot = window.Shopify.routes.root;

				// loop through products and build HTML
				products.forEach(product => {
					const image = `${product.images[0].src}&width=180`;
					const price = product.variants[0].price;
					const onOffer = product.compare_at_price && product.compare_at_price > price;
			
					productHTML += `
					<div class="mega-menu__featured-product">
						<div class="card-product-simple">
							<div class="card-product-simple__img">
								<img src="${image}" alt="${product.title}" loading="lazy" width="180" height="180" class="mega-menu__featured-product-image">
								${onOffer ? '<div class="card__badge"><span class="badge badge--bottom-left color-accent-2">Sale</span></div>' : ''}
        					</div>
							</div>
							<div class="card-product-simple__info">
								<h3><a href="${siteRoot}products/${product.handle}" class="full-unstyled-link"><span class="truncate">${splitProductTitle(product.title)}</span></a></h3>
								 
							</div>
						</div>
					</div>
					`;
				});

				// if we have HTML, update featuredProducts
				if (productHTML) {
					featuredProducts.innerHTML = productHTML;
				}

				featuredProducts.dataset.populated = true; //set to true so we don't load again
			});
	};
};		


const menuItems = document.querySelector(".spiral-primary-nav").querySelectorAll("details");
const initMenus = new SV.HoverIntent(menuItems, {
	onEnter: function(targetItem) {
		targetItem.setAttribute("open", true);
		populateTopProducts(targetItem);
	},
	onExit: function(targetItem) {
		targetItem.removeAttribute("open");
	},
	exitDelay: 200,
	interval: 70,
	sensitivity: 5,
});